import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavigateBefore = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#1D1B20",
		d: "m14 18-6-6 6-6 1.4 1.4-4.6 4.6 4.6 4.6L14 18Z"
	})
});
export { SvgNavigateBefore as ReactComponent };
